import { useEffect, useState } from "react";
import { getTimeAgo } from "../../../utils/commonUtils";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    refreshInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      color: '#757575',
      fontSize: '12px',
    },
    refreshLabel: {
      color: '#757575',
    },
    refreshTime: {
      color: '#9e9e9e',
    },
}))

const LastRefreshedTime = ({lastRefreshedTime}) => {
    const classes = useStyles();
    const [timeAgo, setTimeAgo] = useState(null);

    useEffect(() => {
        const updateTime = () => {
          setTimeAgo(getTimeAgo(lastRefreshedTime));
        };
    
        updateTime();
    
        const interval = setInterval(updateTime, 5000);
    
        return () => clearInterval(interval);
      }, [lastRefreshedTime]);

    return(
        <div className={classes.refreshInfo}>
            <span className={classes.refreshLabel}>Last refreshed</span>
            <span className={classes.refreshTime}>{timeAgo}</span>
        </div>
    )
}

export default LastRefreshedTime;